import { useParams } from 'react-router-dom';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { useAlert, AlertType } from 'src/components/AlertsProvider';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { generateApiPath } from 'src/utils';
import { useStoreUnitActions } from 'src/redux/helpers';
import {
  API_ASSET_MAPING_CONFIG_POST,
  API_PUT_OMNIVERSE_APP,
} from '../../constants';
import solutionsStore, {
  useCurrentSolutionName,
  useSolutionDetails,
} from '../../redux';
import { SolutionMappingConfigItem, SolutionOmniverseApp } from '../../types';
import SolutionMappingEditModal from './SolutionMappingEditModal';
import SolutionOmniverseEditModal from './SolutionOmniverseEditModal';

type Props = {
  item: SolutionOmniverseApp;
  sitesId?: string;
  id?: string;
  open: boolean;
  onClose: ModalCloseHandler;
};

function SolutionOmniverseCreateContainer({
  item,
  sitesId,
  id,
  open,
  onClose,
}: Props) {
  const { showAlert } = useAlert();
  const { solutionId } = useParams();
  const solutionName = useCurrentSolutionName();
  const actions = useStoreUnitActions(solutionsStore);
  const [solutionDetails] = useSolutionDetails();
  const isISA95Standard = solutionDetails?.isIsa95Standard || false;

  const [onSubmit, loading] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Put,
        url: generateApiPath(API_PUT_OMNIVERSE_APP, {
          solutionId,
          siteId: sitesId,
          appId: '00',
          twinId: id,
        }),
        params,
      }),
    (res, params) => {
      showAlert({
        type: AlertType.Success,
        title: 'App Created',
        text: `${params.title} has been created successfully`,
      });
      onClose(null, ModalCloseReason.completeAction);
      actions.omniverseApp({
        solutionId,
        siteId: sitesId,
        appId: item?.id || '00',
        twinId: id,
      });
    }
  );

  return (
    <SolutionOmniverseEditModal
      title="Create New Application"
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      loading={loading}
    />
  );
}

export default SolutionOmniverseCreateContainer;
